export default __webpack_public_path__ + "static/media/reckitt_logo_white.696acef0.svg";